import { render } from "./ComponentSideBar.vue?vue&type=template&id=29abcbb3&scoped=true"
import script from "./ComponentSideBar.vue?vue&type=script&lang=js"
export * from "./ComponentSideBar.vue?vue&type=script&lang=js"

import "./ComponentSideBar.vue?vue&type=style&index=0&id=29abcbb3&scoped=true&lang=css"

import exportComponent from "/home/avatar_milano/avatar.web/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29abcbb3"]])

export default __exports__